import { FC, useContext, useMemo } from "react";
import { Waffles } from "@app/shared/waffles/Waffles";
import { ColumnConfig, wafflesKeyColumnName } from "@app/shared/waffles/exports";
import GapOverviewChart from "@app/overviews/enterprise-compliance-dashboard/components/GapOverviewChart";
import { EcdGenerateReportContext } from "@app/overviews/enterprise-compliance-dashboard/contexts/EcdGenerateReportContext";
import { filterToTimeFrame } from "@app/overviews/enterprise-compliance-dashboard/utility";

interface GapOverviewDrillInData {
  [wafflesKeyColumnName]: string;
  dateRange: string;
  gaps: string;
}

const columnConfig: ColumnConfig = {
  dateRange: {
    displayText: "Date Range",
    noSort: true,
    style: { fontSize: "10px" },
    testId: "date-range",
  },
  gaps: {
    displayText: "Number of Gaps",
    noSort: true,
    style: { fontSize: "10px" },
    testId: "number-of-gaps",
  }
}

const GapOverviewExport: FC = () => {
  const wizardContext = useContext(EcdGenerateReportContext);
  const title = "Gap Overview";

  const slicedGapOverviewData = useMemo(() => {
    return filterToTimeFrame(wizardContext.gapOverviewData, wizardContext.gapOverviewTimeFrame, 4);
  }, [wizardContext.gapOverviewData, wizardContext.gapOverviewTimeFrame]);

  const tableData = slicedGapOverviewData.map((row) => {
    return {
      /* oxlint-disable sort-keys */
      [wafflesKeyColumnName]: row.week,
      dateRange: row.week + " - " + row.weekEnd,
      gaps: row.gapCount.toLocaleString()
      /* oxlint-enable sort-keys */
    }
  });

  //cut off array when rows will exceed one page in export
  if (tableData.length > 15)
    tableData.length = 15;

  return (
    <div className="ecd-export__wrapper">
      <div style={{ display: "flex" }}>
        <h2 className="qes-dashboard-tile__title ecd-export__head">{title}</h2>
        <h2 className="qes-dashboard-tile__title ecd-export__head" style={{ marginLeft: "auto", order: "2" }}>{"Time Frame: " + wizardContext.gapOverviewTimeFrame}</h2>
      </div>
      <GapOverviewChart
        gapOverviewData={slicedGapOverviewData}
        adequacyBreakdownData={wizardContext.adequacyBreakdownData}
        gapsArray={wizardContext.gapsArray}
        isExport={true}
      />
      <br />
      {wizardContext.addGraphDetails && (
        <div className="ecd-export__table">
          <h2 className="qes-dashboard-tile__title ecd-export__head">{title + " Details"}</h2>
          <Waffles<GapOverviewDrillInData>
            columns={columnConfig}
            data={tableData}
            fullWidth={true}
            loading={tableData.length === 0}
            testId="ecd-export-gap-overview__table"
          />
        </div>
      )}
    </div>
  );
}

export default GapOverviewExport;